export const INC_TIMER_DATA = "INC_TIMER_DATA";
export const RESET_TIMER_DATA = "RESET_TIMER_DATA";
export const IS_SET = "IS_SET";

export const SET_TASKS_DATA = "SET_TASKS_DATA";

export const resetTimerData = () => {
  return {
    type: RESET_TIMER_DATA,
  };
};

export const isSet = () => {
  return {
    type: IS_SET,
  };
};

export const incTimerData = () => {
  return {
    type: INC_TIMER_DATA,
    
  };
};

export const setTasksData = (data) => {
  return {
    type: SET_TASKS_DATA,
    data,
  };
};

